// extracted by mini-css-extract-plugin
export default {"dark":"HW12_dark__roShW","dark-text":"HW12_dark-text__gKSe3","red":"HW12_red__I9lBt","red-text":"HW12_red-text__Dy0gj","some":"HW12_some__jsgjY","some-text":"HW12_some-text__Y4f0U"};